import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { SelectItem } from '@openng/optimus-ui/api';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { InputText } from '@openng/optimus-ui/inputtext';
import { InputNumber } from '@openng/optimus-ui/inputnumber';
import { Checkbox } from '@openng/optimus-ui/checkbox';
import { Panel } from '@openng/optimus-ui/panel';
import { Select } from '@openng/optimus-ui/select';
import { Textarea } from '@openng/optimus-ui/textarea';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/core/components/base.component';
import { InlineValidationComponent } from 'src/app/core/components/inline-validation.component';
import {
  CommercialFacility,
  CommercialFacilityContactSummary,
} from 'src/app/model/commercial-services/commercial-facility';
import { AOR, AORContactSummary } from 'src/app/model/locations/aor';

@Component({
  selector: 'app-commercial-facility-form',
  templateUrl: './commercial-facility-form.component.html',
  styleUrls: ['./commercial-facility-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ButtonDirective,
    InputText,
    InputNumber,
    Checkbox,
    Panel,
    Select,
    Textarea,
    Tooltip,
    TranslatePipe,
    InlineValidationComponent,
  ],
})
export class CommercialFacilityFormComponent extends BaseComponent {
  readonly form = input<UntypedFormGroup | undefined>();
  readonly facility = input<CommercialFacility | null>(null);
  readonly availableCompanies = input<SelectItem[]>([]);
  readonly availableFacilityTypes = input<SelectItem[]>([]);
  readonly availableOperatingAreas = input<SelectItem[]>([]);
  readonly availableMarketAreas = input<SelectItem[]>([]);
  readonly availableAORs = input<SelectItem[]>([]);
  readonly availableBalancingTypes = input<SelectItem[]>([]);
  readonly availableMCFacilities = input<SelectItem[]>([]);
  readonly aors = input<AOR[]>([]);
  readonly canOpenContacts = input(false);
  readonly canOpenMcFacility = input(false);
  readonly operatingAreaChanged = output<string | null>();
  readonly openMcFacility = output<string>();
  readonly openContact = output<string>();

  getDerivedContact(
    contactType: 'gcSupervisor' | 'gcManager'
  ): AORContactSummary | CommercialFacilityContactSummary | null {
    const facility = this.facility();
    const form = this.form();
    const aorId = form?.get('aorId')?.value;
    const selectedAor = this.aors().find((aor) => aor.id === aorId);
    const selectedContact = selectedAor?.[contactType];
    const existingContact =
      facility?.aorId === aorId ? facility?.[contactType] : null;

    return selectedContact ?? existingContact ?? null;
  }
}
